import { Injectable } from '@angular/core';
import {
  ReferenceFile,
  ReferenceFileCompact
} from '@stratus/gss-ng-sdk';
import {IReferenceFile} from '@models/settings/reference-file';
import {ReferenceFileCompactReferenceFileSortFieldsPagedItems} from '@stratus/gss-ng-sdk';
import { get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReferenceFileMapperService {

  constructor(
  ) { }

  mapApiItemsToDataSourceModel(item: ReferenceFileCompact | ReferenceFile): IReferenceFile {
    return {
      fileName: item.name,
      displayName: item.displayName || item.name,
      isIllumina: item.isIllumina || false,
      fileType: item.type,
      description: item.description,
      dataLocationUri: item.dataLocationUri,
      supportedGenomesCount: item.supportedGenomesCount,
      referenceFileId: item.id,
      supportedGenomeIds: get(item, 'supportedGenomes') ?
        (item as ReferenceFile).supportedGenomes.map(genome => genome.id) : [],
      timeModified: item.timeModified,
      status: get(item, 'status'),
      isNotDownloadable: item.isNotDownloadable || false,
      systemTags: this.mapSystemTagsToRows(get(item, 'systemTags'))
    };
  }

  private mapSystemTagsToRows(apiTags: Array<{[key: string]: string}>): Array<{key: string, values: string[]}> {
    if (!apiTags || !apiTags.length) {
      return null;
    }
    var grouped: {[key: string]: string[]} = {};
    apiTags.forEach(function(tagObj) {
      var key = Object.keys(tagObj)[0];
      var value = tagObj[key];
      if (!grouped[key]) {
        grouped[key] = [];
      }
      if (value != null && value !== '') {
        grouped[key].push(value);
      }
    });
    return Object.keys(grouped).map(function(key) {
      return { key: key, values: grouped[key] };
    });
  }

  mapApiResponseListToDataSourceList(response: ReferenceFileCompactReferenceFileSortFieldsPagedItems)
    : IReferenceFile[] {
    if (!response.items) {
      return [];
    }
    return response.items
      .map(item => this.mapApiItemsToDataSourceModel(item));
  }
}
